import angular from 'angular';
import template from './item.html';
import './item.scss';
import { getFirstFocusableInContainer } from '../../../utils/focus-utils';
class ModalsItemController {
    constructor($element, $timeout) {
        this.$element = $element;
        this.$timeout = $timeout;
    }
    $onInit() {
        // Ensure focus moves into the modal when it opens (e.g. from the call menu).
        // Prefer the close control so device-setting selects are not focused on open
        // (which would open their dropdown via bs-select).
        void this.$timeout(() => {
            const root = this.$element[0];
            const closeButton = root.querySelector('.modals-item__close');
            if (closeButton) {
                closeButton.focus();
                return;
            }
            const content = root.querySelector('.modals-item__content');
            const firstFocusable = content && getFirstFocusableInContainer(content);
            firstFocusable?.focus();
        }, 0);
    }
}
const modalsItem = {
    template,
    transclude: true,
    bindings: {
        header: '<',
        closeAriaLabel: '<',
        onClose: '&',
    },
    controller: ModalsItemController,
};
export default angular
    .module('doxy.common.components.modals.item', [])
    // modals-item
    .component('modalsItem', modalsItem).name;
